// startup
// Load entry module and return exports
__webpack_require__("./src/assets/scripts/modern/accordion.js");
__webpack_require__("./src/assets/scripts/modern/custom.js");
// This entry module used 'module' so it can't be inlined
__webpack_require__("./src/assets/scripts/modern/jquery-tabs.min.js");
var __webpack_exports__ = __webpack_require__("./src/assets/scripts/modern/lazysizes.init.js");
